import { ReactNode, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from './authContext';
import { USER_AUTH } from '../../Constant';
import { ValidateCodeRequestResponse } from 'api/authenticationApi';
import { identifyPostHogUser, resetPostHogUser } from '../../posthog';

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const store = localStorage.getItem(USER_AUTH);
  const [state, setState] = useState<ValidateCodeRequestResponse | undefined>(
    JSON?.parse(store ?? '{}')
  );
  const [isCustomer, setIsCustomer] = useState<boolean | null>(null);
  const [isMerchant, setIsMerchant] = useState<boolean | null>(null);
  const [hasSettingsPermission, setHasSettingsPermission] = useState<
    boolean | null
  >(null);
  const [hasOperationsPermission, setHasOperationsPermission] = useState<
    boolean | null
  >(null);
  const [hasSuperAdminPermission, setHasSuperAdminPermission] = useState<
    boolean | null
  >(null);
  const [hasViewOnlyPermission, setHasViewOnlyPermission] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    if (store) {
      const user: ValidateCodeRequestResponse = JSON.parse(store);
      setState(user);
    } else {
      setState(undefined);
    }
    // eslint-disable-next-line
  }, [store, location?.pathname]);

  useEffect(() => {
    if (state?.user?.active) {
      const roles = state?.user?.registrations?.[0]?.roles || [];

      identifyPostHogUser({
        id: state?.user?.id,
        email: state?.user?.email,
        username: state?.user?.username,
        fullName: state?.user?.fullName,
        accountName: state?.user?.registrations?.[0]?.data?.accountName,
        roles,
      });
    } else {
      resetPostHogUser();
    }
  }, [state]);

  useEffect(() => {
    if (state! && state?.user?.active) {
      // const currentPath = window.location.pathname;
      // if (!allowedPaths.includes(currentPath)) {
      //   navigate('/');
      // }
      const roles = state?.user?.registrations?.[0]?.roles || [];
      const isCustomer = roles?.includes('customer');
      const isMerchant = roles?.includes('merchant');
      setIsCustomer(isCustomer);
      setIsMerchant(isMerchant);

      if (roles?.[0] === 'admin') {
        setHasSettingsPermission(roles?.includes('settings'));
        setHasOperationsPermission(roles?.includes('operation'));
        setHasViewOnlyPermission(roles?.includes('view'));

        const isSuperAdmin =
          roles?.includes('settings') &&
          roles?.includes('operation') &&
          roles?.includes('view');
        setHasSuperAdminPermission(isSuperAdmin);
      }
    } else {
      const { pathname, search } = location;
      if (pathname !== '/login' && pathname !== '/register') {
        navigate('/login', {
          state: {
            from: `${pathname}${search}`,
          },
        });
      }
    }
    // eslint-disable-next-line
  }, [state, navigate]);

  return (
    <AuthContext.Provider
      value={{
        state,
        setState,
        isCustomer,
        setIsCustomer,
        isMerchant,
        setIsMerchant,
        hasSettingsPermission,
        setHasSettingsPermission,
        hasOperationsPermission,
        setHasOperationsPermission,
        hasSuperAdminPermission,
        setHasSuperAdminPermission,
        hasViewOnlyPermission,
        setHasViewOnlyPermission,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
